import sdl from '@jds/react-generated-sdl/JDSDatepickerYearView';
import type { JDSDatepickerYearViewProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerYearViewProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSDatepickerYearView',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerYearView = withLogic(
  Component
) as React.FC<JDSDatepickerYearViewProps> & { slotName?: string };

DatepickerYearView.displayName = 'DatepickerYearView';
DatepickerYearView.slotName = 'jds_datepicker_year_view';

export { DatepickerYearView, type JDSDatepickerYearViewProps };
